import * as i from "./index.es5498.js";
import { stringToRGBArray as n } from "./index.es521.js";
const o = {};
for (let e = 1; e <= 8; e++)
  for (let t = 1; t <= 4; t++) {
    const r = `trade-area-POI-${e}-TA${t}`, a = `POI_${e}_TA${t}`;
    o[r] = {
      paletteName: `POI-${e}-TA${t}`,
      paletteColors: n(i[a])
    };
  }
const A = (e) => Object.entries(o).map(([t, r]) => t.includes(`TA${e.toString()}`) ? r : void 0).filter((t) => t);
export {
  o as TRADE_AREA_PALETTE_DICTIONARY,
  A as getTradeAreaPalettesDictionary
};
//# sourceMappingURL=index.es51.js.map
